import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';

Vue.use(VueRouter);

export default function({ store, ssrContext }) {
  const Router = new VueRouter({
    scrollBehavior: () => ({ x: 0, y: 0 }),
    routes,
    mode: process.env.VUE_ROUTER_MODE,
    base: process.env.VUE_ROUTER_BASE
  });

  Router.beforeEach((to, from, next) => {
    
    document.cookie.split(";").forEach(cookie => {
      document.cookie = cookie.replace(/^ +/, "").replace(/=.*/, `=;expires=${new Date(0).toUTCString()};path=/`);
    });

    // If the path is code, go to that route
    if(to.path === '/code') {
      next();
      return;
    }

    if (to.matched.some(record => record.meta.requiresAuth)) {
      store.dispatch('auth/checkAuthUser')
        .then(() => next())
        .catch(() => next({ path: '/' }));
    } else {
      store.dispatch('auth/checkAuthUser')
        .then(() => next({ path: '/home' }))
        .catch(() => next());
    }
  });

  return Router;
}
